import { createSlice } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '../../../wb-core/common/Constants';

const initialState = {
  job: null,
  jobs: [],
  loadingJobs: LOADING_STATUS.notLoading,
};

export const adminJobsSlice = createSlice({
  name: 'adminJobs',
  initialState,
  reducers: {
    setJob: (state, action) => {
      const { job } = action.payload;
      state.job = job;
    },
    setJobs: (state, action) => {
      const { jobs } = action.payload;
      state.jobs = jobs;
    },
    setLoadingJob: (state, action) => {
      state.loadingJob = action.payload;
    },
    setLoadingJobs: (state, action) => {
      state.loadingJobs = action.payload;
    },
    cleanJobsSlice() {
      return initialState;
    }
  },
});

export const {
  cleanJobsSlice,
  setJob,
  setJobs,
  setLoadingJob,
  setLoadingJobs,
} =
  adminJobsSlice.actions;

export default adminJobsSlice.reducer;
